module.exports = __webpack_public_path__ + "img/matcha02_300px.359a13b5.jpg";